'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getElementChildrenSorted = exports.getElementChildren = exports.getElement = undefined;

var _reselect = require('reselect');

var _boardConstants = require('../boards/boardConstants');

var _elementHelper = require('./elementHelper');

var getElement = exports.getElement = (0, _reselect.createSelector)(function (state) {
    return state.get('elements');
}, function (state, props) {
    return props.elementId;
}, function (elements, elementId) {
    return { element: elements.get(elementId) };
});

var getElementChildren = exports.getElementChildren = function getElementChildren() {
    return (0, _reselect.createSelector)(function (state) {
        return state.get('elements');
    }, function (state, props) {
        return props.element.get('id');
    }, function (elements, elementId) {
        return (0, _elementHelper.getChildren)(elements, elementId);
    });
};

var getElementChildrenSorted = exports.getElementChildrenSorted = function getElementChildrenSorted() {
    return (0, _reselect.createSelector)(getElementChildren(), function (children) {
        return (0, _elementHelper.getSortedChildrenInSection)(children, _boardConstants.BOARD_SECTIONS.INBOX);
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementSelector.js
// module id = 2269
// module chunks = 0